import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import moment from "moment";
import Breadcrumb from "../component/Breadcumb.js";

class ProductionPlanningEntry extends Component {
  constructor(props) {
    super(props);
    this.productionServices = new ProductionServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isGridView: true,
      isLoading: "",
      isEditing: false,
      isAllFieldDisable: false,
      tableStatus: "",
      itemListing: [],
      partyDropdownList: [],
      productDropdownList: [],
      companyItemList: [],
      productionPlanningList: [],
      filterDetails: {
        partyName: "",
        productName: "",
        filterBy: "",
        productionStageId: [1],
      },
      productDetails: {
        productDetialsId: "",
        partyId: "",
        productId: "",
        batchNo: "",
        batchSize: "",
        planningDate: "",
        despDate: "",
        itemId: "",
        despQty: "",
        mrp: "",
        packing: 0,
        salesRate: "",
        itemId2: "",
        despQty2: "",
        mrp2: "",
        salesRate2: "",
        packing2: 0,
        productionStageId: 0,
      },
      filterByList: [
        { filterBy: "Prod.No.", value: "productionNo" },
        { filterBy: "Prod.Date", value: "productionPlanningDate" },
        { filterBy: "Batch No", value: "batchNo" },
      ],
      productionTypeList: [
        { type: "Production Planning", value: 1 },
        { type: "Production Requisition", value: 2 },
        { type: "Packing Requisition", value: 3 },
        { type: "Pending Batches", value: 4 },
      ],
      validationRules: {
        partyId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "party name"
            ),
          },
        ],
        productId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
        batchNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch no"
            ),
          },
        ],
        batchSize: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch size"
            ),
          },
        ],
        planningDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "planning date"
            ),
          },
        ],
        despDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "despatch date"
            ),
          },
        ],
        itemId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "item name"
            ),
          },
        ],
        despQty: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "despatch qty"
            ),
          },
        ],
        mrp: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "MRP"
            ),
          },
        ],
        salesRate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "sales rate"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllProductionPlanningEntry();
  }

  getAllProductionPlanningEntry = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails;
    this.productionServices
      .getAllProductionPlanningEntry(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let res = response.responseData;
          if (res.length === 0) {
            this.setState({ noItemFound: "No item found" });
          }
          this.setState({ productionPlanningList: res }, () => {
            this.getAllPartyDropdown();
          });
        } else {
          this.setState({ tableStatus: "" })
          this.getAllPartyDropdown();
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.partyName,
          value: item._id,
        }));
        this.setState({ partyDropdownList: dropdownItems }, () => {
          this.getAllProductDropdown();
        });
      } else {
        this.getAllProductDropdown();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllProductDropdown = () => {
    this.commonServices.getAllProductDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.productName,
          value: item._id,
        }));
        this.setState({ productDropdownList: dropdownItems }, () => {
          this.getAllItem();
        });
      } else {
        this.getAllItem();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
          packing: item.Packing,
        }));

        this.setState({ companyItemList: dropdownItems });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};

    let Fdetails = this.state.filterDetails;
    Fdetails.partyName = "";
    Fdetails.productName = "";
    Fdetails.filterBy = "";

    let details = this.state.productDetails;
    details.productDetialsId = "";
    details.partyId = "";
    details.productId = "";
    details.batchNo = "";
    details.packing = 0;
    details.packing2 = 0;
    details.batchSize = "";
    details.planningDate = "";
    details.despDate = "";
    details.itemId = "";
    details.despQty = "";
    details.mrp = "";
    details.salesRate = "";
    details.itemId2 = "";
    details.despQty2 = "";
    details.mrp2 = "";
    details.salesRate2 = "";
    details._id = null;
    this.setState({ productDetails: details, filterDetails: Fdetails, validState: validState, isEditing: false, tableStatus: "" }, () => { this.getAllProductionPlanningEntry(); });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    if (section === "filterDetails") {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState({ filterDetails: details }, () => {
        this.getAllProductionPlanningEntry();
      });
    } else if (section === "productDetails") {
      let details = this.state.productDetails;
      details[name] = value.toUpperCase();
      this.setState({ productDetails: details });
    }
  };

  handleDropDownChange = (e, name) => {
    const select = e.target.value;
    let details = this.state.filterDetails;
    if (name === 'productionStageId') {
      details.productionStageId = [Number(select)]
    } else {
      details[name] = select;
    }
    this.setState({ filterDetails: details }, () => {
      this.getAllProductionPlanningEntry();
    });
  };

  setFilterParameters = (selected, drpIdentity, section) => {
    let details = this.state.productDetails;

    if (section === "productDetails") {
      details[drpIdentity] = selected.value;
      if (drpIdentity === "itemId") {
        details.packing = selected.packing ? selected.packing : "";
      }
      if (drpIdentity === "itemId2") {
        details.packing2 = selected.packing ? selected.packing : "";
      }
      this.setState({ productDetails: details });
    }
  };

  addEditProductionPlanningEntry = (isDirectProduction) => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {

      let request = this.state.productDetails;
      if (request.productDetialsId === "") {
        delete request.productDetialsId;
      }

      if (isDirectProduction === true) {
        request.productionStageId = 2;
        this.setState({ isLoading: "production" })
      } else {
        request.productionStageId = 1;
        this.setState({ isLoading: "add" })
      }

      if (request.itemId2 === '' && request.itemId2.trim() === '') {
        delete request.itemId2
      }

      if (request.itemId === '' && request.itemId.trim() === '') {
        delete request.itemId
      }

      this.productionServices
        .addEditProductionPlanningEntry(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.SwalServices.Success(response.Message);
            this.resetForm();
            this.setState({ isLoading: "" })
            this.getAllProductionPlanningEntry();
            this.setState({ isGridView: true });
          } else {
            this.SwalServices.Error(
              response.Message
            );
            this.setState({ isLoading: "" })
          }
        });
    }
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.productDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  getProductionPlanningEntryById = (id) => {
    this.productionServices
      .getProductionPlanningEntryById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let details = response.responseData;
          details.planningDate = moment(details.planningDate).format(
            "yyyy-MM-DD"
          );
          details.despDate = moment(details.despDate).format("yyyy-MM-DD");
          details.productDetialsId = details._id;
          details.productId = details.productId._id;
          details.productionStageId =
            details.productionStageStatusId.productionStageId;

          if (details.productionStageStatusId.productionStageId > 1) {
            this.setState({ isAllFieldDisable: true });
          }
          this.setState({ productDetails: details }, () => {
            this.setState({ isGridView: false, isEditing: true });
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  deleteProductionPlanningEntryById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete ?`
    ).then((response) => {
      if (response === true) {
        this.productionServices
          .deleteProductionPlanningEntryById(id)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              this.getAllProductionPlanningEntry();
              this.SwalServices.Success(response.Message);
            } else {
              this.SwalServices.Error(
                response.Message
              );
            }
          });
      }
    })
  };

  render() {
    const activePage = "Production Planning";

    return (
      <div className="productionPlanning-page">
        {this.state.isGridView === true ? (
          <>
            {/* <Breadcrumb page={activePage} /> */}
            <div className='flex gap-[8px] items-center mb-[8px]'>
              {/* <div className="h-[20px] w-[20px]"><FontAwesomeIcon icon={faCalendarDays} style={{ height: "100%", width: "100%", }} />
              </div> */}

              <p className='text-lg font-bold text-gray-700'>Production Planning</p>
            </div>
            <div className="item-search mb-3.5">
              <div className="item-grp mb-3 grid grid-cols-4 gap-2.5">
                {/* <div className="search-grp">
                  <label>Party Name:</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="party-name"
                    name="partyName"
                    autoComplete="off"
                    value={this.state.filterDetails.partyName}
                    onChange={(event) =>
                      this.handleChange(event, "partyName", "filterDetails")
                    }
                  />
                </div> */}
                <div className="search-grp">
                  <label>Product Name:</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="product-name"
                    name="productName"
                    autoComplete="off"
                    value={this.state.filterDetails.productName}
                    onChange={(event) =>
                      this.handleChange(event, "productName", "filterDetails")
                    }
                  />
                </div>
                <div className="search-grp">
                  <label>Filter By:</label>
                  <select
                    name="filterBby"
                    value={this.state.filterDetails.filterBy}
                    onChange={(event) =>
                      this.handleDropDownChange(
                        event,
                        "filterBy",
                        "filterDetails"
                      )
                    }
                  >
                    <option>Select</option>
                    {this.state.filterByList.map((x, key) => (
                      <option key={key} value={x.value}>
                        {x.filterBy}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="search-grp">
                  <label>Production Stage:</label>
                  <select
                    name="filterBby"
                    value={this.state.filterDetails.productionStageId}
                    onChange={(event) =>
                      this.handleDropDownChange(
                        event,
                        "productionStageId",
                        "filterDetails"
                      )
                    }
                  >
                    {this.state.productionTypeList.map((x, key) => (
                      <option key={key} value={x.value}>
                        {x.type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <button className="add-btn" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <div className="table-container" style={{ height: "calc(100vh - 220px)" }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "7%" }}>Prod.No</td>
                      <td style={{ width: "10%" }}>Prod.Date</td>
                      {/* <td style={{ width: "15%" }}>Party Name</td> */}
                      <td style={{ width: "20%" }}>Product Name</td>
                      <td style={{ width: "10%" }}>Batch No</td>
                      <td style={{ width: "10%" }}>Batch Size</td>
                      <td style={{ width: "15%" }}>Status</td>
                      <td style={{ width: "10%", textAlign: "center" }}>
                        Action
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.productionPlanningList &&
                      this.state.productionPlanningList.length > 0
                      ? this.state.productionPlanningList.map((item, key) => (
                        <tr key={key}>
                          <td>{item.productionNo}</td>
                          <td>
                            {item.productionPlanningDate
                              ? moment(item.productionPlanningDate).format(
                                "DD MMM yyyy"
                              )
                              : ""}
                          </td>
                          {/* <td>
                            {item.partyId?.partyName
                              ? item.partyId.partyName
                              : ""}
                          </td> */}
                          <td>
                            {item.productId?.productName
                              ? item.productId?.productName
                              : ""}
                          </td>
                          <td>{item.batchNo}</td>
                          <td>{item.batchSize}</td>
                          <td>
                            {item.productionStageStatusId.productionStageName}
                          </td>
                          <td className="!text-center">
                            <button
                              className="search-btn"
                              onClick={() =>
                                this.getProductionPlanningEntryById(item._id)
                              }
                              title="Edit"
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            {item.productionStageStatusId.productionStageId === 1 ?
                              <button
                                className="cancel-btn"
                                onClick={() =>
                                  this.deleteProductionPlanningEntryById(
                                    item._id
                                  )
                                }
                                title="Delete"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                              : null}
                          </td>
                        </tr>
                      ))
                      : this.state.productionPlanningList &&
                        this.state.productionPlanningList.length === 0
                        && this.state.tableStatus !== "" ? (
                        <tr>
                          <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                            {this.state.tableStatus}
                          </td>
                        </tr>
                      ) : this.state.productionPlanningList &&
                        this.state.productionPlanningList.length === 0
                        && this.state.tableStatus === "" ? null : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : null}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table">
                <div className="item-grp grid grid-cols-2 gap-2.5 mb-3">
                  <div className="input-grp">
                    <label>Party Name</label>
                    <MultiSelectDropdown
                      className={`  ${this.state.validState?.error?.partyId ? "errorInput" : ""}`}
                      drpIdentity="partyId"
                      options={this.state.partyDropdownList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(
                          selected,
                          "partyId",
                          "productDetails"
                        )
                      }
                      allowSelectAll={false}
                      value={this.state.partyDropdownList.filter(
                        (party) =>
                          party.value === this.state.productDetails.partyId
                      )}
                      isDisabled={this.state.isAllFieldDisable}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.partyId}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Product Name</label>
                    <MultiSelectDropdown
                      className={`  ${this.state.validState?.error?.productId ? "errorInput" : ""}`}
                      drpIdentity="productId"
                      options={this.state.productDropdownList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(
                          selected,
                          "productId",
                          "productDetails"
                        )
                      }
                      allowSelectAll={false}
                      value={this.state.productDropdownList.filter(
                        (party) =>
                          party.value === this.state.productDetails.productId
                      )}
                      isDisabled={this.state.isAllFieldDisable}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.productId}
                    /> */}
                  </div>
                </div>
                <div className="item-grp grid grid-cols-4 gap-2.5 mb-3">
                  <div className="input-grp">
                    <label>Batch No</label>
                    <input
                      className={` inputFocus ${this.state.validState?.error?.batchNo ? "errorInput" : ""}`}
                      type="text"
                      id="batchNo"
                      name="batchNo"
                      autoComplete="off"
                      disabled={this.state.isAllFieldDisable}
                      value={this.state.productDetails.batchNo}
                      onChange={(event) =>
                        this.handleChange(event, "batchNo", "productDetails")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.batchNo}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Batch Size</label>
                    <input
                      className={` inputFocus ${this.state.validState?.error?.batchSize ? "errorInput" : ""}`}
                      type="number"
                      id="batchSize"
                      name="batchSize"
                      autoComplete="off"
                      disabled={this.state.isAllFieldDisable}
                      value={this.state.productDetails.batchSize}
                      onChange={(event) =>
                        this.handleChange(event, "batchSize", "productDetails")
                      }
                      onWheel={(e) => e.target.blur()}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.batchSize}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Planning Date</label>
                    <input
                      type="date"
                      id="planningDate"
                      name="planningDate"
                      autoComplete="off"
                      disabled={this.state.isAllFieldDisable}
                      className={` inputFocus ${this.state.validState?.error?.planningDate ? "errorInput" : ""}`}
                      value={this.state.productDetails.planningDate}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "planningDate",
                          "productDetails"
                        )
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.planningDate}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Despatch Date</label>
                    <input
                      type="date"
                      id="despDate"
                      name="despDate"
                      autoComplete="off"
                      disabled={this.state.isAllFieldDisable}
                      className={` inputFocus ${this.state.validState?.error?.despDate ? "errorInput" : ""}`}
                      value={this.state.productDetails.despDate}
                      onChange={(event) =>
                        this.handleChange(event, "despDate", "productDetails")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.despDate}
                    /> */}
                  </div>
                </div>
                <div className="item-out-grp mt-4">
                  <span
                    className="text-lg font-bold text-gray-700 "
                  >
                    Packing details
                  </span>
                  <div className="item-inner-grp grid grid-cols-2 gap-2.5 mb-2 mt-1.5">
                    <div className="itemInner-grp flex gap-2.5">
                      <div className="input-grp w-[80%]">
                        <label>Item Name</label>
                        <MultiSelectDropdown
                          drpIdentity="itemId"
                          className={`  ${this.state.validState?.error?.itemId ? "errorInput" : ""}`}
                          options={this.state.companyItemList}
                          // isMulti
                          // components={{
                          //   Option
                          // }}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={(selected) =>
                            this.setFilterParameters(
                              selected,
                              "itemId",
                              "productDetails"
                            )
                          }
                          allowSelectAll={false}
                          value={this.state.companyItemList.filter(
                            (party) =>
                              party.value === this.state.productDetails.itemId
                          )}
                          isDisabled={this.state.isAllFieldDisable}
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.itemId}
                        /> */}
                      </div>
                      <div className="input-grp w-[20%]">
                        <label>Packing</label>
                        <input
                          type="text"
                          value={this.state.productDetails.packing || ""}
                          disabled
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="itemInner-grp grid grid-cols-3 gap-2.5">
                      <div className="input-grp">
                        <label>Desp. Qty.</label>
                        <input
                          className={` inputFocus ${this.state.validState?.error?.despQty ? "errorInput" : ""}`}
                          type="number"
                          id="despQty"
                          name="despQty"
                          autoComplete="off"
                          disabled={this.state.isAllFieldDisable}
                          value={this.state.productDetails.despQty}
                          onChange={(event) =>
                            this.handleChange(event, "despQty", "productDetails")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.despQty}
                        /> */}
                      </div>
                      <div className="input-grp">
                        <label>M.R.P.</label>
                        <input
                          className={` inputFocus ${this.state.validState?.error?.mrp ? "errorInput" : ""}`}
                          type="number"
                          id="mrp"
                          name="mrp"
                          autoComplete="off"
                          disabled={this.state.isAllFieldDisable}
                          value={this.state.productDetails.mrp}
                          onChange={(event) =>
                            this.handleChange(event, "mrp", "productDetails")
                          }
                        />
                        {/* <ValidationText error={this.state.validState.error.mrp} /> */}
                      </div>
                      <div className="input-grp">
                        <label>Sales Rate</label>
                        <input
                          className={` inputFocus ${this.state.validState?.error?.salesRate ? "errorInput" : ""}`}
                          type="number"
                          id="salesRate"
                          name="salesRate"
                          autoComplete="off"
                          value={this.state.productDetails.salesRate}
                          onChange={(event) =>
                            this.handleChange(
                              event,
                              "salesRate",
                              "productDetails"
                            )
                          }
                          disabled={this.state.isAllFieldDisable}
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.salesRate}
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div className="item-inner-grp grid grid-cols-2 gap-2.5">
                    <div className="itemInner-grp flex gap-2.5">
                      <div className="input-grp w-[80%]">
                        <MultiSelectDropdown
                          className={`  ${this.state.validState?.error?.itemId2 ? "errorInput" : ""}`}
                          drpIdentity="itemId2"
                          options={this.state.companyItemList}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={(selected) =>
                            this.setFilterParameters(
                              selected,
                              "itemId2",
                              "productDetails"
                            )
                          }
                          allowSelectAll={false}
                          value={this.state.companyItemList.filter(
                            (party) =>
                              party.value === this.state.productDetails.itemId2
                          )}
                          isDisabled={this.state.isAllFieldDisable}
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.itemId2}
                        /> */}
                      </div>
                      <div className="input-grp w-[20%]">
                        <input
                          type="text"

                          value={this.state.productDetails.packing2 || ""}
                          disabled
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="itemInner-grp grid grid-cols-3 gap-2.5">
                      <div className="input-grp">
                        <input
                          className={` inputFocus ${this.state.validState?.error?.despQty2 ? "errorInput" : ""}`}
                          type="number"
                          id="despQty2"
                          name="despQty2"
                          autoComplete="off"
                          disabled={this.state.isAllFieldDisable}
                          value={this.state.productDetails.despQty2}
                          onChange={(event) =>
                            this.handleChange(event, "despQty2", "productDetails")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.despQty2}
                        /> */}
                      </div>
                      <div className="input-grp">
                        <input
                          className={` inputFocus ${this.state.validState?.error?.mrp2 ? "errorInput" : ""}`}
                          type="number"
                          id="mrp2"
                          name="mrp2"
                          autoComplete="off"
                          disabled={this.state.isAllFieldDisable}
                          value={this.state.productDetails.mrp2}
                          onChange={(event) =>
                            this.handleChange(event, "mrp2", "productDetails")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.mrp2}
                        /> */}
                      </div>
                      <div className="input-grp">
                        <input
                          className={` inputFocus ${this.state.validState?.error?.salesRate2 ? "errorInput" : ""}`}
                          type="number"
                          id="salesRate2"
                          name="salesRate2"
                          autoComplete="off"
                          disabled={this.state.isAllFieldDisable}
                          value={this.state.productDetails.salesRate2}
                          onChange={(event) =>
                            this.handleChange(
                              event,
                              "salesRate2",
                              "productDetails"
                            )
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validState.error.salesRate2}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="btn-grp mt-4">
                {/* {this.state.isEditing === true ? (
                  <button
                    disabled={this.state.isAllFieldDisable}
                    className="add-btn"
                    onClick={() => this.addEditProductionPlanningEntry(false)}
                  >
                    Save
                  </button>
                ) : (
                  <button
                    disabled={this.state.isAllFieldDisable}
                    className="add-btn"
                    onClick={() => this.addEditProductionPlanningEntry(false)}
                  >
                    Add
                  </button>
                )} */}
                {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading || this.state.isAllFieldDisable}
                    onClick={() => this.addEditProductionPlanningEntry(false)}
                  >
                    {this.state.isLoading === "add" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading || this.state.isAllFieldDisable}
                    onClick={() => this.addEditProductionPlanningEntry(false)}
                  >
                    {this.state.isLoading === "add" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                  </button>
                )}
                <button
                  className="cancel-btn"
                  onClick={() => this.openGridView()}
                  disabled={this.state.isLoading}
                >
                  Cancel
                </button>
                <button
                  disabled={this.state.isAllFieldDisable || this.state.isLoading}
                  className="print-btn"
                  onClick={() => this.addEditProductionPlanningEntry(true)}
                >
                  {this.state.isLoading === "production" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : " Proceed to Production"}
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
export default ProductionPlanningEntry;
